import Manager from 'coreClasses/Manager';
import {timeout} from 'coreUtils/utils';

/**
 * Represents a Banning Manager
 */
class BanningMgr extends Manager {
	/**
	 * Check if banning logic is applied for the specified customer group
	 * @param {string|null} customerGroupName customer group name
	 * @return {boolean} true if banning logic is applied
	 */
	async isBanned(customerGroupName: string | null): Promise<boolean> {
		while (!this.managerRepository.getCustomerMgr().getCurrentCustomer().isReady()) {
			await timeout(50);
		}

		if (!customerGroupName) {
			return false;
		}

		return !this.managerRepository.getCustomerMgr().getCurrentCustomer().isMemberOfCustomerGroup(customerGroupName);
	}
}

export default BanningMgr;
